<template>
  <div style="padding-bottom:20px">
    <div class="container deal">
      <div class="first-party">
        <van-cell title="甲方名称" value="广东哈弗石油能源股份有限公司" />
        <van-cell
          title="乙方(代理商)"
          :value="agreementContent.partyABusinessLicenseName"
        />
        <div class="module-title">丙方信息</div>
        <van-field
          v-model="agreementContent.partyBName"
          label="丙方(门店)"
          placeholder="请输入门店营业执照名称"
        />
        <van-cell title="负责人姓名" :value="agreementContent.partyBRealName" />
        <van-cell title="负责人手机号" :value="agreementContent.partyBPhone" />
        <van-field
          readonly
          clickable
          name="picker"
          :value="agreementContent.idType | idType"
          label="证件类型"
          placeholder="请选择"
          @click="idTypePicker = true"
        />
        <div class="papers-img">
          <p class="title">营业执照</p>
          <div class="edit-img" v-if="agreementContent.idNoImage">
            <van-image
              width="88"
              height="88"
              fit="contain"
              :src="$imgPath + agreementContent.idNoImage"
              @click="previewImg"
            >
            </van-image>
            <van-icon name="clear" @click="beforeDelete" />
          </div>
          <van-uploader
            v-model="fileList"
            v-if="!agreementContent.idNoImage"
            multiple
            :max-count="1"
            :after-read="afterRead"
            :before-delete="beforeDelete"
            :before-read="beforeRead"
          />
        </div>
        <van-field
          v-if="agreementContent.idType === 1"
          v-model="agreementContent.idNo"
          label="证件号码"
          maxlength="18"
          placeholder="请输入证件号码"
        />
        <van-field
          v-if="agreementContent.idType === 2"
          v-model="agreementContent.idNo"
          label="证件号码"
          maxlength="18"
          placeholder="请输入证件号码"
        />
        <van-cell title="广告位置" :value="agreementContent.advertAddress" />
        <van-cell title="完成时间" :value="agreementContent.finishAt" />
      </div>
      <div class="module-title">丙方义务</div>
      <div class="second-party">
        <div>
          <span>连续经营哈弗润滑油不少于</span>
          <span style="color:red">{{
            agreementContent.minOperationYears
          }}</span>
          <span>年</span>
        </div>
        <div>
          <span>进货哈弗产品总价值不低于</span>
          <span style="color:red">{{
            agreementContent.minPurchaseValue / 10000
          }}</span>
          <span>万元</span>
        </div>
        <div>
          <span>首批进货总价值不低于</span>
          <span style="color:red">{{
            agreementContent.firstPurchaseValue
          }}</span>
          <span>元</span>
        </div>
        <div>
          <span>首批进货最迟截止日期</span>
          <span style="color:red">{{
            agreementContent.firstLatestPurchaseDate
          }}</span>
        </div>
      </div>
      <div class="module-title">广告报销方式</div>
      <div v-for="(item, index) in refundArr" :key="index" class="refund">
        丙方进货满<span>{{
          item.stockPrice > 10000
            ? item.stockPrice / 10000 + "万"
            : item.stockPrice
        }}</span
        >元时,甲方报销<span>{{ item.refund }}</span
        >元
      </div>
      <div class="remark">
        备注：实际广告报销费用以哈弗公司财务部最终核算的金额为准
      </div>
      <div class="checkbox">
        <van-checkbox v-model="checked">
          <span>我已阅读并同意</span>
          <span class="agreement" @click="toAgreementDetail">
            《广告牌投放协议》
          </span>
          <span>内容</span>
        </van-checkbox>
      </div>
      <van-button
        class="reject"
        type="danger"
        @click="handlerReject"
        v-show="hideSubmitBtn"
        >驳回</van-button
      >
      <van-button
        type="primary"
        @click="handlerSubmit"
        v-show="hideSubmitBtn"
        :loading="subStatus"
        loading-text="提交中"
        >确定无误</van-button
      >
    </div>
    <van-popup v-model="idTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="idTypeColumns"
        @confirm="onIdType"
        @cancel="idTypePicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { Toast } from "vant";
import { ImagePreview } from "vant";
import * as imageConversion from "image-conversion";
import { Dialog } from "vant";
export default {
  data() {
    return {
      idTypeColumns: ["营业执照", "身份证"],
      idTypePicker: false,
      agreementContent: "",
      refundArr: [],
      hideSubmitBtn: true,
      adID: "",
      subStatus: false,
      fileList: [],
      checked: false
    };
  },
  filters: {
    idType(type) {
      switch (type) {
        case 1:
          return "身份证";
        case 2:
          return "营业执照";
        default:
          return "";
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      this.adID = JSON.parse(sessionStorage.getItem("adID"));
      this.$api.adDetails(this.adID).then(res => {
        console.log("广告申请: ", res);
        res = res.result;
        this.apply = res.apply;
        this.agreementContent = res.apply;
        if (sessionStorage.getItem("apply")) {
          this.agreementContent = JSON.parse(sessionStorage.getItem("apply"));
        }
        this.refundArr = JSON.parse(res.apply.reimbursementMethod);
        if (this.agreementContent.status > 0) {
          this.hideSubmitBtn = false;
        }
        if (
          this.agreementContent.status === 0 &&
          !sessionStorage.getItem("apply")
        ) {
          Dialog.alert({
            title: "温馨提示",
            message:
              "您好！请认真核对《广告投放协议》中的内容与您实际的信息是否相符，若不相符，请进行修改和补充，谢谢合作！"
          });
        }
      });
    },
    // 证件类型
    onIdType(value, index) {
      this.agreementContent.idType = index === 0 ? 2 : 1;
      this.idTypePicker = false;
    },
    // 提交
    handlerSubmit() {
      if (!this.handleRules()) {
        return;
      }
      Dialog.confirm({
        title: "温馨提示",
        confirmButtonText: "信息无误，确认提交",
        cancelButtonText: "取消，再次核对",
        message:
          "本协议具备法律效力，请仔细核对协议中的信息，确保与您实际的信息完全一致。"
      })
        .then(() => {
          this.subStatus = true;
          let formData = {
            advertApplyId: this.adID,
            confirm: true,
            idNo: this.agreementContent.idNo,
            idNoImage: this.agreementContent.idNoImage,
            idType: this.agreementContent.idType,
            partyBName: this.agreementContent.partyBName
          };
          // console.log(formData);
          this.$api.firstConfirm(formData).then(res => {
            if (res.code === 0) {
              this.subStatus = false;
              Dialog.alert({
                title: "提示",
                message: "您的广告申请已提交！",
                confirmButtonText: "关闭"
              }).then(() => {
                this.init();
                this.hideSubmitBtn = false;
                window.close();
              });
            } else {
              this.subStatus = false;
              Dialog.alert({
                title: "提示",
                message: "提交失败,请检查",
                confirmButtonText: "关闭"
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 驳回
    handlerReject() {
      Dialog.confirm({
        title: "温馨提示",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        message: "是否确定驳回"
      })
        .then(() => {
          this.subStatus = true;
          let formData = {
            advertApplyId: this.adID,
            confirm: false,
            idNo: this.agreementContent.idNo,
            idType: this.agreementContent.idType,
            partyBName: this.agreementContent.partyBName
          };
          // console.log(formData);
          this.$api.firstConfirm(formData).then(res => {
            if (res.code === 0) {
              this.subStatus = false;
              Dialog.alert({
                title: "提示",
                message: "已驳回",
                confirmButtonText: "关闭"
              }).then(() => {
                this.init();
                this.hideSubmitBtn = false;
                window.close();
              });
            } else {
              this.subStatus = false;
              Dialog.alert({
                title: "提示",
                message: "提交失败,请检查",
                confirmButtonText: "关闭"
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 表单检验
    handleRules() {
      if (!/[\u4e00-\u9fa5]/gm.test(this.agreementContent.partyBName.trim())) {
        this.$toast("营业执照请输入中文");
        return false;
      }
      if (!this.agreementContent.idType) {
        this.$toast("请选择证件类型");
        return false;
      }
      if (this.agreementContent.idNo.trim() === "") {
        this.$toast("请输入证件号码");
        return false;
      }
      if (this.agreementContent.idNoImage.trim() === "") {
        this.$toast("请上传营业执照");
        return false;
      }
      if (
        this.agreementContent.idType === 1 &&
        this.agreementContent.idNo.length != 18
      ) {
        this.$toast("请检查身份证位数");
        return false;
      }
      if (
        this.agreementContent.idType === 2 &&
        this.agreementContent.idNo.length != 18
      ) {
        this.$toast("请检查营业执照位数");
        return false;
      }
      if (!this.checked) {
        this.$toast("请勾选协议");
        return false;
      }
      return true;
    },
    // 协议详情
    toAgreementDetail() {
      sessionStorage.setItem("apply", JSON.stringify(this.agreementContent));
      this.$router.push("/shop/agreementDetail");
    },
    // 上传图片前
    beforeRead(file) {
      if (file.type != "image/png" && file.type != "image/jpeg") {
        this.$toast("请上传png、jpeg图片格式");
        return false;
      }
      return new Promise(resolve => {
        const isLt2M = file.size / 1024 < 900;
        if (isLt2M) {
          resolve(file);
        } else {
          imageConversion.compressAccurately(file, 900).then(res => {
            let files = new window.File([res], file.name, {
              type: file.type
            });
            resolve(files);
          });
        }
      });
    },
    //图片上传
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let content = file.file;
      let data = new FormData();
      data.append("img", content);
      this.$api
        .uploadImg(data)
        .then(res => {
          // console.log(res);
          file.status = "done";
          file.message = "上传成功";
          // this.adContent.realSceneImg.push(res.url);
          this.agreementContent.idNoImage = res.url;
        })
        .catch(err => {
          console.log(err);
          this.fileList.splice(this.fileList.length - 1, 1);
          Toast("上传超时,请再次尝试");
        });
    },
    // 图片删除
    beforeDelete() {
      // this.fileList.splice(detail.index, 1);
      // this.adContent.realSceneImg.splice(detail.index, 1);
      this.fileList = [];
      this.agreementContent.idNoImage = "";
    },
    //预览图片
    previewImg(e) {
      ImagePreview([e.srcElement.src]);
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 10px;

  .module-title {
    padding: 5px 0;
    background-color: #eaeaea;
  }

  .second-party {
    div {
      padding: 10px 20px;
      text-align: left;
      font-size: 14px;
    }
  }

  .papers-img {
    padding: 10px 20px;
    text-align: left;
    color: #646566;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;

    .title {
      margin-right: 120px;
    }

    .van-image {
      margin-right: 5px;
    }

    .edit-img {
      position: relative;

      .van-icon {
        position: absolute;
        top: 0;
        right: 5px;
        color: #969799;
        font-size: 18px;
      }
    }
  }

  .agreement-detail {
    display: block;
    margin-bottom: 20px;
    font-size: 12px;
  }

  .checkbox {
    margin-bottom: 20px;
    .agreement {
      color: #00a0e9;
    }
  }

  .van-checkbox {
    display: flex;
    justify-content: center;
  }

  .refund {
    padding: 10px 20px;
    text-align: left;
    font-size: 14px;

    span {
      color: red;
    }
  }

  .remark {
    margin-bottom: 10px;
    padding: 0 20px;
    text-align: left;
    color: red;
    font-size: 14px;
  }

  .reject {
    margin-right: 20px;
  }
}

.van-cell {
  padding: 10px 20px;
}

.van-cell__title,
.van-cell__value {
  text-align: left;
}

.van-field__label {
  text-align: left;
}
</style>
<style lang="scss">
.deal {
  .van-field__label {
    text-align: left;
    flex: 1;
  }
  .van-dialog__message {
    font-size: 14px;
  }

  // .van-field__control {
  //   color: #969799;
  // }
  ::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: red;
  }

  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: red;
  }

  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: red;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: red;
  }
}
</style>
